import { ThemeAPI } from '@ingestro/importer-react'

import { buttons } from './buttons'
import { columnMatch } from './columnMatch'
import { dropzone } from './dropzone'
import { headerSelect } from './headerSelect'
import { joinSheet } from './joinSheet'
import { loader } from './loader'
import { messagePopup } from './messagePopup'
import { popover } from './popover'
import { popoverInfo } from './popoverInfo'
import { progressBar } from './progressBar'
import { reviewEntries } from './reviewEntries'
import { root } from './root'
import { sheetSelect } from './sheetSelect'

export const getStyle = (isEdition: boolean | undefined, totalRows?: number): ThemeAPI => ({
  buttons,
  dropzone,
  sheetSelect,
  headerSelect,
  loader,
  progressBar,
  columnMatch,
  joinSheet,
  popover,
  popoverInfo,
  messagePopup,
  reviewEntries,
  root: root(isEdition, totalRows),
})
